module.exports = __webpack_public_path__ + "img/sec3_slide3_mobile.6b32cd8e.jpg";